export const VerificationNames = {
  EMR: 'EMR',
  OshaCitation: 'OSHA Citation'
} as const;

export interface IVerification {
  legacyId: number;
  name: string;
  status: string;
  isVerified: boolean | null;
  questionnaireSectionId: number;
  expirationDate: string | null;
  expiringPeriodDays: number;
  questionSectionId: string;
  isPendingReview: boolean;
}
